// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_stateChange", inline: true, disabled: false };
const msgs = {
  stateChange: (CHANGE) => [`coverState:`, CHANGE],
  no_change: ["No change to state provided."],
  no_someEl: ["state change hdl.", "stateChange", "no some el. found"],
};

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_coverState(CHANGES) {
  if (!("coverState" in CHANGES)) return this.logger("error", msgs.no_change, "error", logArgs);

  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { coverState } = CHANGES;
  const { coverImgEl } = this.ref;
  this.logger("state-change", msgs.stateChange(coverState), "default", { ...logArgs, inline: false });

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////// is_hidden ///////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  if ("is_hidden" in coverState) {
    const { is_hidden } = coverState;
    coverImgEl.setAttribute("data-is-hidden", is_hidden ? "true" : "false");
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
